import React from "react";

export const UserManagementContext = React.createContext({
    userManagementData: undefined,
    updateUserManagementData: (data: any) => {},
  });